export const restaurantsListLoading = state => state.restaurant.listData.loading;
export const restaurantListFetched = state => state.restaurant.listFetched;
export const restaurantsListData = state => state.restaurant.listData;
export const currentRestaurant = state => state.restaurant.currentItem;
export const currentItemInProcessSelector = state => state.restaurant.currentItemInProcess;

export const restaurantErrors = state => state.restaurant.errors;
export const updateOrCreateInProcess = state => state.restaurant.updateOrCreateInProcess;
export const deleteInProcessSelector = state => state.restaurant.deleteInProcess;
